<template>
	<div>
		<v-row class="font-weight-medium" style="font-size: 18px">
			<v-col class="mt-6">
				<div>ID: {{ contrattoDiServizio.id }}</div>
				<div>Ragione Sociale Contratto: {{ contrattoDiServizio.ragione_sociale }}</div>
				<div>Cognome Referente: {{ contrattoDiServizio.cognome_referente_accordo }}</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-progress-linear
					v-if="isLoadingContrattoDiServizioTags || isDetachingTag"
					indeterminate
					color="primary"
				></v-progress-linear>
				<div
					v-else-if="contrattoDiServizioTags.length == 0"
					class="font-weight-medium primary--text text-h6"
				>
					Nessun Tag
				</div>
				<template
					v-else
					v-for="tag in contrattoDiServizioTags"
				>
					<v-text-field
						v-model="tag.text"
						outlined
						dense
						readonly
						append-icon="mdi-trash-can-outline"
						@click:append="detachTag(tag)"
						:disabled="syncInProgress"
					></v-text-field>
				</template>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-form ref="newOrSelectedTagForm">
					<v-combobox
						ref="newOrSelectedTagCombobox"
						v-model="newOrSelectedTag"
						:items="allTags"
						:loading="isLoadingAllTags"
						:disabled="isLoadingAllTags || syncInProgress || isDetachingTag"
						:search-input.sync="searchTag"
						autocomplete="nope"
						clearable
						dense
						item-text="text"
						item-value="id"
						label="Tags"
						outlined
						return-object
					></v-combobox>
				</v-form>
			</v-col>
			<v-col>
				<v-btn
					color="secondary"
					@click="syncTags()"
					:loading="syncInProgress"
				>
					Aggiungi Tag
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['contrattoDiServizio'],
	data() {
		return {
			isLoadingAllTags: false,
			isLoadingContrattoDiServizioTags: false,
			contrattoDiServizioTags: [],
			searchTag: null,
			allTags: [],
			newOrSelectedTag: null,
			syncInProgress: false,
			isDetachingTag: false
		}
	},
	
	created() {
		this.getContrattoDiServizioTags();
		this.getAllTags();
	},
	
	computed: {
		isLoading() {
			return this.syncInProgress
				|| this.isDetachingTag;
		}
	},
	
	watch: {
		isLoading(boolean) {
			this.$emit('is-loading', boolean)
		}
	},
	
	methods: {
		getAllTags() {
			this.isLoadingAllTags = true;
			axios.get('/api/tags', {
				params: {
					without_tags_of_this_contratto_di_servizio_id: this.contrattoDiServizio.id
				}
			})
				.then(response => {
					this.allTags = response.data;
					
					// rimuovo i tags già assegnati alla contrattoDiServizio
					// this.contrattoDiServizioTags.forEach(contrattoDiServizioTag => {
					// 	this.$delete(this.allTags, this.allTags.findIndex(tag => tag.id == contrattoDiServizioTag.id));
					// })
				})
				.finally(() => {
					this.isLoadingAllTags = false;
				})
		},
		getContrattoDiServizioTags() {
			this.isLoadingContrattoDiServizioTags = true;
			return axios.get(`/api/tags`, {
				params: {
					contratto_di_servizio_id: this.contrattoDiServizio.id
				}
			})
				.then(response => {
					this.contrattoDiServizioTags = response.data;
				})
				.finally(() => {
					this.isLoadingContrattoDiServizioTags = false;
				})
		},
		syncTags() {
			this.$refs.newOrSelectedTagCombobox.blur();
			this.$nextTick(() => {
				if (this.newOrSelectedTag === null) return;
				
				this.syncInProgress = true;
				
				let newTag = null;
				let contrattoDiServizioTags = Object.assign([], this.contrattoDiServizioTags);
				
				if (typeof this.newOrSelectedTag == 'string') newTag = this.newOrSelectedTag;
				else contrattoDiServizioTags.push(this.newOrSelectedTag);
				
				axios.post('/api/tags/sync', {
					type: 'contratto_di_servizio',
					contratto_di_servizio_id: this.contrattoDiServizio.id,
					new_tag: newTag,
					contratto_di_servizio_tags: contrattoDiServizioTags
				})
					.then(() => {
						this.newOrSelectedTag = null;
						this.$emit('tags-updated', {
							contrattoDiServizio: this.contrattoDiServizio
						})
						this.getContrattoDiServizioTags();
						this.getAllTags();
					})
					.finally(() => {
						this.syncInProgress = false;
					})
			})
		},
		detachTag(tag) {
			this.isDetachingTag = true;
			this.$delete(this.contrattoDiServizioTags, this.contrattoDiServizioTags.findIndex((contrattoDiServizioTag) => contrattoDiServizioTag.id == tag.id));
			
			axios.post('/api/tags/sync', {
				type: 'contratto_di_servizio',
				contratto_di_servizio_id: this.contrattoDiServizio.id,
				contratto_di_servizio_tags: this.contrattoDiServizioTags
			})
				.then(() => {
					this.$emit('tags-updated', {
						contrattoDiServizio: this.contrattoDiServizio
					})
					this.getContrattoDiServizioTags();
					this.getAllTags();
				})
				.finally(() => {
					this.isDetachingTag = false;
				})
		}
	}
}
</script>